import React from "react";
import cx from "classnames";
import { GatsbyImage, getImage, ImageDataLike } from "gatsby-plugin-image";

import * as s from "./UpdateCard.module.sass";

export type IUpdateCard = {
  image: ImageDataLike;
  title: string;
  uri: string;
};

type UpdateCardProps = {
  update: IUpdateCard;
};

export const UpdateCard: FC<UpdateCardProps> = ({
  update: { image, title, uri },
  className,
}) => {
  const imagePrepared = getImage(image)!;

  return (
    <a
      href={`https://story.madfish.solutions${uri}`}
      target="_blank"
      rel="nofollow noreferrer"
      className={cx(s.root, className)}
    >
      <span className={s.imageWrapper}>
        <GatsbyImage image={imagePrepared} alt={title} className={s.image} />
        <span className={s.imageEffects} />
      </span>
      {title}
    </a>
  );
};
